import { Tracking } from './../../providers/tracking';
import { ToastMessage } from './../../providers/toast-message';
import { ElePage } from './../ele/ele';
import { Component } from '@angular/core';
import { AlertController, IonicPage, NavController, NavParams } from 'ionic-angular';
import firebase from 'firebase';

/**
 * User edit
 * 
 */
@IonicPage()
@Component({
  selector: 'page-user',
  templateUrl: 'user.html',
})
export class UserPage extends ElePage {

  constructor(public navCtrl: NavController, public navParams: NavParams, 
              public alertCtrl: AlertController, public toastMsg: ToastMessage, public tracking : Tracking) {
    super(navCtrl, navParams);
    // Sur new ele
    if (!this.eleId) {
      this.ele = { level: 'read', disabled: false };
    }
  }

  ionViewDidEnter() {
    this.tracking.view(this);
  }


  ionViewDidLoad() {
    console.log('ionViewDidLoad UserPage');
  }


  onResetPassword(email) {
    firebase.auth().sendPasswordResetEmail(email).then( (x)=>{ 
      this.toastMsg.success('eMail was sent successfully');
    }).catch( (err)=>{
      this.toastMsg.error('sendPasswordResetEmail error: ' + err);
    });
  }


   onDeleteEle() {

    let confirm = this.alertCtrl.create({
      title: 'Delete this user ?',
      message: 'Are you sure to delete this user ?',
      buttons: [
        {
          text: 'No',
          handler: () => { console.log('No'); }
        },
        {
          text: 'Yes',
          handler: () => {
            super.onDeleteEle();            
          }
        }
      ]
    });
    confirm.present();

  }


}



// WEBPACK FOOTER //
// ./src/pages/user/user.ts